module.exports = "<svg width=\"117\" height=\"92\" viewBox=\"0 0 117 92\" xmlns=\"http://www.w3.org/2000/svg\"><g stroke=\"#CCC\" stroke-width=\"4\" stroke-linejoin=\"round\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M2 51h26.04v38.592H2zM44 2h26.04v87.056H44zM88 34h26.04v54.746H88z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeSVGTagAttrs=false&removeTags=true!./src/scripts/components/campaign/images/rate.svg
// module id = Eaba
// module chunks = 89